<p [innerHTML]="priceString"></p>